<template>
  <section class="page-section">
    <div class="container" :style="{display: !isLoading ? 'block' : 'none'}">
      <div class="tabs-container" >
        <div class="tabs">
          <ul class="tabs-component-tabs">
            <li v-for="tab in tabs" :key="tab.id" class="tabs-component-tab" :class="{'is-active' : tab.id === activeTab.id}" @click="setActiveTab(tab)">
              {{tab.name}} <span class="badge">{{tab.items.length}}</span>
            </li>
          </ul>
          <div class="tabs-content" v-for="tab in tabs" :key="tab.id" :class="{'is-active' : tab.id === activeTab.id}">
            <div class="cta-inner text-center rounded" :id="`tab-desc-${tab.id}`" v-html="tab.desc">
            </div>
            <div class="tab-imgs-container">
              <img v-for="(item, idx) in tab.items" :key="idx" :src="require('../assets/img/presta/' + item)" :alt="'Emery Paysages '+tab.name +'-'+ idx" />
            </div>
          </div>
        </div>
      </div>
      <div id="scroller">
        <button class="btn btn-primary" v-scroll-to="{ element: '#mainNav', duration: 1000 }">
            <i class="fas fa-angle-up"></i>
        </button>
      </div>
    </div>
    <div class="container" :style="{display: isLoading ? 'block' : 'none'}">
      <div class="row justify-content-center">
        <MoonLoader />
      </div>
    </div>
  </section>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { nosPrestations } from '@/data/prestations.js'

export default {
  name: "NosPrestations",
  components: {
    MoonLoader
  },
  data() {
    return {
      isLoading: !localStorage.visitPresta,
      tabs: nosPrestations.prestations,
      activeTab: null
    };
  },
  created() {
    let tous = {id: 0, name: "Tous", desc: "<b class='text-primary'>Emery Paysages</b> vous invite à découvrir toutes les activités et services proposés, à l'aide de cette galerie photo.", items: []};

    this.tabs.forEach(presta => {
      for (let i = 0; i < presta.items.length; i++) {
        tous.items.push(presta.items[i]);
      }
    });

    this.shuffle(tous.items);
    this.activeTab = tous;

    if (this.tabs.length <= 5) { 
      this.tabs.unshift(tous);
    }
    
    setTimeout(() => {
      this.isLoading = false;
    }, 800)
  },
  mounted() {
    if (!localStorage.visitPresta) {
      localStorage.visitPresta = true;
    }

    if (this.$route.params.id && this.$route.params.id <= 5) {
      this.activeTab = this.tabs[this.$route.params.id]
    }
  },
  methods: {
    setActiveTab: function (tab) {
      this.activeTab = tab;
    },
    shuffle: function (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    }

  }
};
</script>

<style lang="scss">
#tab-desc-2 > img {
  max-width: 150px;
  position: absolute;
  bottom: 5px;
  right: 5px;
}

@media only screen and (max-width: $mobile) {
  #tab-desc-2 > img {
    top: 5px;
    right: 30%;
    left: 30%;
  }

  #tab-desc-2 {
    padding-top: 80px;
  }
}

.tabs {
  color: $white;
}

.tabs-component-tabs {
  margin-bottom: 15px;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}

@media only screen and (min-width: $mobile) and (max-width: $tablet) {
  .tabs-component-tabs {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media only screen and (max-width: $mobile) {
  .tabs-component-tabs {
    grid-template-columns: 1fr;
  }
}

.tabs-component-tab {
  color: $grey70;
  font-size: 14px;
  margin-right: 0 !important;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  text-transform: uppercase;
  position: relative;
  cursor: pointer;
  text-align: center;
}

.tabs-component-tab:hover {
  color: $primary !important;
}

.tabs-component-tab.is-active {
  background-color: $primary;
  color: $white;
  font-weight: 600;
}

.tabs-component-tab.is-active:hover {
  color: $white !important;
}

.badge {
  display: none;
  position: absolute;
  top: -8px;
  right: -8px;
  border: 1px solid $white;
  background-color: $white;
  color: $primary;
}

.tabs-component-tab.is-active .badge {
  display: block;
}

.tabs-content {
  opacity: 0;
  height: 0;
  overflow: hidden;
}

.tabs-content.is-active {
  opacity: 1;
  height: auto;

  -webkit-animation: fadeInLeft .5s both;
  -moz-animation: fadeInLeft .5s both;
  -o-animation: fadeInLeft .5s both;
  animation: fadeInLeft .5s both;

  padding: 0 15px;
}

.cta-inner {
  position: relative;
  padding: 2rem;
  margin: 0 0 1rem;
  background-color: rgba(255, 255, 255, 0.85);
  color: $black;
}

.tab-imgs-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
}

.tab-imgs-container img {
  max-width: 100%;
  opacity: .5;
}

@media only screen and (min-width: $mobile) {
  .tab-imgs-container img {
    height: 100%;
  }
}

@media only screen and (min-width: $mobile) and (orientation: landscape) {
  .tab-imgs-container img {
    max-height: 100%;
  }
}

@media only screen and (max-width: $tablet) {
  .tab-imgs-container img {
    opacity: 1;
  }
}

.tab-imgs-container img:hover {
  transition: opacity .5s ease-out;
  opacity: 1;
}

@media only screen and (min-width: $mobile) and (max-width: $tablet) {
  .tab-imgs-container {
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: $mobile) {
  .tab-imgs-container {
    grid-template-columns: 1fr;
  }
}

#scroller {
  display: none;
  z-index: 2;
  position: fixed;
  bottom: 50px;
  right: 50px;
}

#scroller button {
  font-size: 2rem;
  width: 60px;
}

#scroller button:focus {
  background-color: $primary;
  border: none;
  box-shadow: none;
}

/* Defines fadeInLeft animation for all browsers */
@-webkit-keyframes fadeInLeft {
  from {
    opacity:0;
    -webkit-transform: translatex(-10px);
    -moz-transform: translatex(-10px);
    -o-transform: translatex(-10px);
    transform: translatex(-10px);
  }
  to {
    opacity:1;
    -webkit-transform: translatex(0);
    -moz-transform: translatex(0);
    -o-transform: translatex(0);
    transform: translatex(0);
  }
}

@-moz-keyframes fadeInLeft {
  from {
    opacity:0;
    -webkit-transform: translatex(-10px);
    -moz-transform: translatex(-10px);
    -o-transform: translatex(-10px);
    transform: translatex(-10px);
  }
  to {
    opacity:1;
    -webkit-transform: translatex(0);
    -moz-transform: translatex(0);
    -o-transform: translatex(0);
    transform: translatex(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity:0;
    -webkit-transform: translatex(-100px);
    -moz-transform: translatex(-100px);
    -o-transform: translatex(-100px);
    transform: translatex(-100px);
  }
  to {
    opacity:1;
    -webkit-transform: translatex(0);
    -moz-transform: translatex(0);
    -o-transform: translatex(0);
    transform: translatex(0);
  }
}
</style>